<template>
  <div class='wy-analytics-metrics-zoom-in-on' :class="{'show-shadow': !showSimplifiedVersion}">
    <el-row class='title' v-if="!showSimplifiedVersion">Across all AI-Generated Topics</el-row>
    <el-row class='button-row' v-if="!showSimplifiedVersion">
      <el-button plain 
          v-for="option in metricOptions"
          :key="option.name" 
          :class="{'selected-button': option.name == selectedMetricName}"
          @click="handleSelect(option.name)">
        {{option && option.label}}
      </el-button>
    </el-row>
    <el-row class='metric-card-row'>
      <div class='metric-card-col'>
        <div class='metric-card' :class='{"metric-card-special": showSimplifiedVersion}'>
          <div class='metric-card-title'>
              {{showSimplifiedVersion ? 'Total Conversations' : METRIC_OPTIONS.find((el)=>el.name==selectedMetricName) && METRIC_OPTIONS.find((el)=>el.name==selectedMetricName).label}}
              </div>
            <div class='metric-card-value'>
                <span v-if='totalMetric != "-"'>
                    {{totalMetric}}
                </span>
                <a v-else class="el-no-data" title="Data not available">
                </a>
            </div>
        </div>
      </div>
      <div class='metric-card-col'>
        <div class='metric-card' :class='{"metric-card-special": showSimplifiedVersion}'>
          <div class='metric-card-title'>% change</div>
          <div class='metric-card-value metric-card-value-percentage'>
            <span v-if='compareMetricPercentage != "-" && compareMetricPercentage != 0' class='metric-card-value-sign'>
                {{compareMetricPercentage > 0 ? '↑' : '↓'}}
            </span>
            <span v-if='compareMetricPercentage != "-"'>
                {{Math.abs(parseFloat(compareMetricPercentage))}}%
            </span>
            <span v-else class="no-data">N/A</span>
          </div>
        </div>
        <div v-if='!data'><span>Loading...</span></div>
        <div v-else class='metric-card-footnote'>
          <span v-if='compareMetricPercentage != "-"'>Compared to <b>{{compareMetricValue}}</b> in the last <b>{{data.daysInRange}} days</b></span>
          <span v-else >Correct comparison not available for this time period</span>
          
        </div>
      </div>
    </el-row>

    <div ref='chart'>

    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import WyUtils from '../../../library/wy-utils';
import WyChartModule from '../../../library/wy-chart-module';

export default Vue.extend({
    name: 'wy-interactions-metrics-zoom-in-on',
    props: ['data', 'showSimplifiedVersion'],
    components: {},


    data() {
        return {
            selectedMetricName: 'volumeDMValue',
            wyChart: null,
            METRIC_OPTIONS: [],
        }
    },

    computed: {
        metricOptions: function() {
            if (!this.data)
                return this.METRIC_OPTIONS;
            return this.METRIC_OPTIONS.filter((el) => !this.data[el.name + "Hide"]);
        },

        totalMetric: function() {
            let metric = this.METRIC_OPTIONS.find((el)=>el.name==this.selectedMetricName);
            if (!metric) return '-'

            let totalMetricName = 'total' + metric.name[0].toUpperCase() + metric.name.slice(1);
            if (!this.data || this.data[totalMetricName] == undefined)
                return '-';
            return (metric.disp ? metric.disp(this.data[totalMetricName]) : this.data[totalMetricName]);
        },

        compareMetricPercentage: function() {
            let metric = this.METRIC_OPTIONS.find((el)=>el.name==this.selectedMetricName);
            if (!metric) return '-'

            let compareMetricName = 'compare' + metric.name[0].toUpperCase() + metric.name.slice(1);
            if (!this.data || this.data[compareMetricName] == undefined)
                return '-';
            let totalMetricName = 'total' + metric.name[0].toUpperCase() + metric.name.slice(1);
            if (!this.data || this.data[totalMetricName] == undefined)
                return '-';

            let rounding = metric.rounding ? metric.rounding : (x)=>x;
            return WyUtils.calculatePercentage(rounding(this.data[compareMetricName]), rounding(this.data[totalMetricName]));
        },

        compareMetricValue: function() {
            let metric = this.METRIC_OPTIONS.find((el)=>el.name==this.selectedMetricName);
            if (!metric) return '-'

            let compareMetricName = 'compare' + metric.name[0].toUpperCase() + metric.name.slice(1);
            if (!this.data || this.data[compareMetricName] == undefined)
                return '-';
            
            return (metric.disp ? metric.disp(this.data[compareMetricName]) : this.data[compareMetricName]);
        },
    },

    watch: {
        'data': function(){
            if (this.data)
                this.buildChart();
        },

        'selectedMetricName': function() {
            this.buildChart();
        },

        'metricOptions': function() {
            this.selectedMetricName = this.METRIC_OPTIONS[0].name;
            this.buildChart();
        }
    },

    methods: {
        handleSelect(name) {
            this.selectedMetricName = name;
        },

        buildChart() {
            if (!this.data || !this.selectedMetricName)
                return;

            let metric = this.METRIC_OPTIONS.find((el)=>el.name==this.selectedMetricName);
            if(metric.conv && metric.postfix != '') {
                let maxValue = 0;
                this.data.trend.map((el)=> {
                    if(maxValue < el[metric.name]) {
                        maxValue = el[metric.name]
                    }
                })
                if(maxValue >= 60000) {
                    metric.postfix = 'm'
                }
                else {
                    metric.postfix = 's'
                }
            }
            
            let originalPoints = {
                name: metric.label,
                type: "scatter",
                mode: this.data.trend.length > 1 ? "lines" : "lines+markers",
                cliponaxis: false,
                //marker: {size: median.data.markerSize},
                marker: {/*color: median.data.markerColor,*/ size: 8},
                line: {
                    //shape: 'spline',
                    color: '#214586'
                },
                x: this.data.trend.map((el)=>el.date),
                y: this.data.trend.map((el)=>metric.conv ? metric.conv(el[metric.name]) : el[metric.name]),
                text: this.data.trend.map(()=>(metric.disp ? metric.disp(this.data[metric.name+'Median']) : this.data[metric.name+'Median'])),
                hovertext: this.data.trend.map((el)=>metric.disp ? metric.disp(el[metric.name]) : el[metric.name]),
                //hovertext: median.data.texts,
                hovertemplate: "Date: %{x}<br>Median: %{text}<br>Total: %{hovertext}<extra></extra>",
            };
            let regressionPoints = {
                name: 'Trend',
                type: "scatter",
                mode: "lines",
                cliponaxis: false,
                line: {
                    dash: 'dot',
                    color: '#000',
                    width: 1
                },
                hoverinfo: 'none',
                x: this.data.trend.map((el)=>el.date),
                y: this.data.trend.map((el)=>
                    metric.conv ? metric.conv(el[metric.name+'Regression']) : el[metric.name+'Regression']),
            };
            let medianPoints = {
                name: 'Median',
                type: "scatter",
                mode: "lines",
                cliponaxis: false,
                line: {
                    color: '#000',
                    width: 1
                },
                hoverinfo: 'none',
                x: this.data.trend.map((el)=>el.date),
                y: this.data.trend.map(()=>metric.conv ? metric.conv(this.data[metric.name+'Median']) : this.data[metric.name+'Median']),
            };

            let layout = {
                autosize: true,
                //width: 408,
                height: 220,  
                font: {
                    size: 10
                },
                dragmode: false, //'pan'
                separators: '.',
                showlegend: true,
                plot_bgcolor: 'white',
                hoverlabel: {
                    namelength: 50,
                    font: {
                        size: 11
                    },
                    bordercolor: '#FCFEFF'
                },
                legend: {
                    orientation: 'h',
                    bgcolor: 'rgba(0,0,0,0)',
                    x: 0.38,
                    y: -0.1
                },
                margin: { l: 50, r: 10, t: 20, b: 40 },
                xaxis:  {
                    type: 'date',
                    tickformat: '%b %d %Y',
                    autorange: true,
                    fixedrange: true,
                    //range: [traceData.x[0], traceData.x[traceData.x.length-1]],
                    showgrid: false,
                    zeroline: false,
                    automargin: true,
                    showline: true,
                    linecolor: '#dedede',
                    tickprefix: '',
                    position: 0,
                    ticks: 'inside',
                    tickcolor: "#dedede",
                },
                yaxis: {
                    type: 'linear',
                    autorange: true,
                    //rangemode: 'tozero',
                    separatethousands: true,
                    showgrid: false,
                    showline: true,
                    zeroline: false,
                    linecolor: '#dedede',
                    ticksuffix: ((metric.postfix ? metric.postfix : '') + '  '),
                    //tickformat: (WyUtils[this.format] ? '' : (this.format == 'time' ? '' : this.format)),
                    fixedrange: true,
                    ticks: "inside",
                    tickcolor: "#dedede",
                }
            }        
            let config = {responsive: true, displayModeBar: false, scrollZoom: false, showTips: false};
            // eslint-disable-next-line no-undef
            Plotly.newPlot(this.$refs.chart, [originalPoints, medianPoints, regressionPoints], layout, config);
        }

    },

    mounted() {
        this.wyChart = new WyChartModule();
        
        this.METRIC_OPTIONS = [
            {name: 'volumeDMValue', label: 'Volume', postfix: '',
                conv: (x)=>WyUtils.formatterNumber(x), disp: (x)=>WyUtils.formatterNumber(x)},
            //containmentPercent
            // {name: 'containmentPercent', label: 'Containment Rate', postfix: '%', disp: (x)=>x.toFixed(2)+'%'},
            //aesScoreVolume
            // {name: 'aesScoreVolume', label: 'Agent Experience Score', postfix: '', disp: (x)=>WyUtils.formatterNumber(x)},
            //OC-1173 #1 issue: Change 'Response Time' unit from second to minute
            {name: 'avgHandlingTime', label: 'Avg. Call Handle Time', postfix: 'm', 
                conv: (x)=>{
                    let metric = this.METRIC_OPTIONS.find((el)=>el.name==this.selectedMetricName);
                    if(metric.postfix == 'm') {
                        return  Math.round(x/60)/1000
                    }
                    else{
                        return  x/1000
                    }
                }, disp: (x)=>WyUtils.toNiceTimeFormat(x/1000), rounding: (x)=>(x/60/1000)*60,},
            {name: 'avgResponseTime', label: 'Avg. Response Time', postfix: 'm', 
                conv: (x)=>{
                    let metric = this.METRIC_OPTIONS.find((el)=>el.name==this.selectedMetricName);
                    if(metric.postfix == 'm') {
                        return  Math.round(x/60)/1000
                    }
                    else{
                        return  x/1000
                    }
                }, disp: (x)=>WyUtils.toNiceTimeFormat(x/1000), rounding: (x)=>(x/60/1000)*60,},
            // {name: 'positivePercent', label: 'Positive Sentiment', postfix: '%', disp: (x)=>x.toFixed(2)+'%'},
            // {name: 'negativePercent', label: 'Negative Sentiment', postfix: '%', disp: (x)=>x.toFixed(2)+'%'},
            //hide for OC-1171 {name: 'avgTransfersHide', label: 'Avg. Handoffs'},
        ];
    }
})
</script>

<style lang='scss'>
.show-shadow {
    border: 1px solid transparent;
    border-radius: 4px;
    box-shadow: 0px 2px 6px #0000001a;
    background-color: white;
}

.wy-analytics-metrics-zoom-in-on {
    /* Element UI standard typography */
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;

    width: calc(100% - 45px);
    max-width: 100%;
    min-width: fit-content;
    padding: 20px;
    margin-bottom: 10px;

    .title {
        font-size: 19px;
        font-weight: 700;
    }

    .button-row {
        margin: 20px 0;

        width: fit-content;
        min-width: fit-content;

        display: flex;
        flex-wrap: nowrap;

        .el-button {
            border-radius: 4px;
            font-size: 12px;
            padding: 10px 15px;
        }

        .selected-button, .el-button:hover {
            color: white;
            background-color: #006FE7;
            border: 1px solid transparent;
            font-weight: 500;
        }
    }

    .metric-card-row {
        display: flex;
        flex-direction: row;
        align-items: flex-start;

        .metric-card-col {
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            padding: 10px 0 10px 0;
            margin-right: 10px;

            width: 180px;
            //min-width: fit-content;

            .metric-card {
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                
                height: 53px;
                width: calc(100% - 30px); // 30px = 15px * 2 is the padding
                background-color: rgb(216, 221, 229);
                border-radius: 10px;
                padding: 15px;

                .metric-card-title {
                    font-size: 12px;
                }

                .metric-card-value {
                    font-size: 21px;
                    font-weight: bold;
                    margin-top: 8px;
                    display: flex;
                    align-items: center;
                }

                .metric-card-value-percentage {
                    color: rgb(230, 105, 74);

                    .metric-card-value-sign {
                        //font-family: Font Awesome 5 Pro;
                        margin-right: 5px;
                        @import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200&display=swap');
                        font-family: 'Source Sans Pro', sans-serif;
                    }
                }
            }

            .metric-card-special {
                .metric-card-title {
                    font-size: 16px;
                }
            }

            .error {
                color: red;
            }

            .metric-card-footnote {  // the "compared to x last days" note
                font-size: 10px;
                line-height: 12px;
                margin-top: 5px;
            }
        }
    }
    .el-no-data {
        cursor: pointer;
        background-image: url('../../../assets/icons/icon_comparison_data_not_available.svg') !important;
        background-size: 75%;
        background-repeat: no-repeat;
        background-position-y: 7px;
        background-position-x: 1px;
        background-color: transparent !important;
        height: 26px;
        width: 20px;
        border: 0px;
        margin-left: 0px;
    }

    .el-no-data:hover {
        background-color: unset;
    }
    .no-data {
        color: var(--site-font-primary-color);
    }
}
</style>